<script>
  import QRCode from "qrcode";
  import { onMount } from "svelte";
  let username;

  let gtopQR;
  let topgQR;
  $: gtop = `https://gtop100.com/topsites/MapleStory/sitedetails/MapleLegends-The-Old-School-MapleStory-Server-MAC-Compatible-16-9-Client-No-Hackers-87398?vote=1&pingUsername=${username}`;
  $: topg = `https://topg.org/maplestory-private-servers/in-605064-${username}`;
  $: QRCode.toDataURL(gtop)
    .catch(console.log)
    .then(data => (gtopQR = data));
  $: QRCode.toDataURL(topg)
    .catch(console.log)
    .then(data => (topgQR = data));
  $: username && localStorage.setItem("username", username);

  onMount(() => {
    username = localStorage.getItem("username");
  });
</script>

<style>
  main {
    margin: 0 auto;
    max-width: 50em;
    padding: 0em 2em 2em;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  }

  h1 {
    text-align: center;
  }

  .center {
    text-align: center;
  }

  hr {
    margin-top: 2em;
  }
</style>

<main>
  <h1>Generate QR codes for MapleLegends Voting</h1>

  <p>
    Quickly generate QR codes to
    <a href="https://maplelegends.com/vote">vote for MapleLegends</a>
    that you can bookmark on your phone. See
    <a
      href="https://discordapp.com/channels/101640513408491520/221981749045886987/807557281168228413">
      this discord announcement
    </a>
    on how the direct links work. Leave feedback on the
    <a
      href="https://forum.maplelegends.com/index.php?threads/a-web-app-for-generating-qr-voting-links.37970/">
      forum thread.
    </a>
    Find the
    <a href="https://bitbucket.org/geospiza/geospiza.me/src/main/apps/ml-vote/">
      source code here.
    </a>
  </p>

  <p>
    Need help with voting? Check out
    <a href="https://forum.maplelegends.com/index.php?threads/11493/">
      this voting guide.
    </a>
  </p>

  <h2>Vote for an account</h2>
  <p>
    Enter an account name for voting. Check your
    <a href="https://maplelegends.com/my/account">account details</a>
    to confirm your vote.
  </p>
  <div style="text-align:center">
    <label>
      Username:
      <input bind:value={username} />
    </label>
  </div>
  {#if username}
    <h2>Voting links for {username}</h2>

    <p>
      Click or scan a QR code to visit the voting page. Bookmark these links for
      quick access.
    </p>

    <h3>Voting link for GTOP</h3>
    <div class="center">
      <a href={gtop}>
        <img src={gtopQR} alt="Vote on GTOP" />
      </a>
    </div>
    <h3>Voting link for TOPG</h3>
    <div class="center">
      <a href={topg}>
        <img src={topgQR} alt="Vote on TOPG" />
      </a>
    </div>
  {/if}

  <hr />

  <div style="text-align:center">
    <i>
      Version __VERSION__
      <a
        href="https://bitbucket.org/geospiza/geospiza.me/commits/__GIT_COMMIT__">
        (__GIT_COMMIT__)
      </a>
    </i>
  </div>
</main>
